import { fetchSingleAdminUser } from '@actions/adminUsers';
import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import Modal from '@components/modal/Modal';
import usePrevious from 'lib/src/hooks/usePrevious';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AdminUser } from 'src/types/shared/AdminUser';
import useUpdateAdminPassword from './hooks/useUpdateAdminPassword';
import usePasswordValidation from 'lib/src/hooks/usePasswordValidation';

const UpdateAdminPasswordModal: React.FC<UpdateAdminPasswordProps> = ({
    user: { id },
    closeModal,
}) => {
    const {
        formState: { password, confirmPassword },
        handleChange,
        handleSubmit,
        isPosting,
        postSuccess,
    } = useUpdateAdminPassword(id);
    const { validatePassword, validateConfirmPassword } = usePasswordValidation(password);

    const dispatch = useDispatch();

    const prevPostSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (!prevPostSuccess && postSuccess) {
            closeModal();
            dispatch(fetchSingleAdminUser(id));
        }
    }, [postSuccess, prevPostSuccess, closeModal, dispatch, id]);

    return (
        <Modal title="Update password" size="small" closeModal={closeModal}>
            <Form onCancel={closeModal} onSubmit={handleSubmit} isPosting={isPosting}>
                <FormRow>
                    <TextInput
                        required
                        type="password"
                        name="password"
                        value={password}
                        onChange={handleChange}
                        label="Password"
                        customValidate={validatePassword}
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        required
                        type="password"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={handleChange}
                        customValidate={validateConfirmPassword}
                        label="Confirm password"
                    />
                </FormRow>
            </Form>
        </Modal>
    );
};

interface UpdateAdminPasswordProps {
    user: AdminUser;
    closeModal: () => void;
}

export default UpdateAdminPasswordModal;
